import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';

export const LEGAL_PROCEEDINGS_TABS = {
  RECAP: 0,
  JUDGEMENT_ADD: 1,
  EXPERT_REPORT: 2,
  JUDGEMENT_ON_MERITS: 3,
  JUDGEMENT_APPEAL: 4,
};

export const REQUEST_CREATE_JUDGEMENT_ADD: string =
  'REQUEST_CREATE_JUDGEMENT_ADD';

export const PROCEDURE_NATURES = {
  CORRECTIONAL: '3',
};
export const REQUEST_GET_CIVIL_PROCEEDING: string =
  'REQUEST_GET_CIVIL_PROCEEDING';
export const SET_CIVIL_PROCEEDING: string = 'SET_CIVIL_PROCEEDING';
export const REQUEST_GET_JUDGEMENT_ADD: string = 'REQUEST_GET_JUDGEMENT_ADD';
export const REQUEST_GET_JUDGEMENT_ADD_APPEAL: string =
  'REQUEST_GET_JUDGEMENT_ADD_APPEAL';

export const SET_JUDGEMENT_ADD: string = 'SET_JUDGEMENT_ADD';
export const SET_JUDGEMENT_ADD_APPEAL: string = 'SET_JUDGEMENT_ADD_APPEAL';

export const RESET_JUDGEMENT_STORE: string = 'RESET_JUDGEMENT_STORE';

export const RESET_JUDGEMENT_ADD: string = 'RESET_JUDGEMENT_ADD';
export const RESET_EXPERT_REPORT: string = 'RESET_EXPERT_REPORT';
export const RESET_JUDGEMENT_ON_MERITS: string = 'RESET_JUDGEMENT_ON_MERITS';
export const RESET_MULTIPLE_JUDGEMENT_ON_MERITS: string =
  'RESET_MULTIPLE_JUDGEMENT_ON_MERITS';

export const REQUEST_INSERT_DAHIR_AMOUNT_JOM: string =
  'REQUEST_INSERT_DAHIR_AMOUNT_JOM';

export const REQUEST_GET_DAHIR_AMOUNT_JOM_CORPO: string =
  'REQUEST_GET_DAHIR_AMOUNT_JOM_CORPO';

export const SET_DAHIR_AMOUNT_CORPO: string = 'SET_DAHIR_AMOUNT_CORPO';
export const REQUEST_CREATE_EXPERTISE_RAPORT: string =
  'REQUEST_CREATE_EXPERTISE_RAPORT';

export const REQUEST_GET_EXPERTISE_RAPORT: string =
  'REQUEST_GET_EXPERTISE_RAPORT';

export const REQUEST_GET_EXPERTISE_REPORT_APPEAL: string =
  'REQUEST_GET_EXPERTISE_REPORT_APPEAL';

export const SET_EXPERTISE_RAPORT: string = 'SET_EXPERTISE_RAPORT';
export const SET_EXPERTISE_RAPORT_APPEAL: string =
  'SET_EXPERTISE_RAPORT_APPEAL';

export const REQUEST_CREATE_JUDGEMENT_ON_MERITS: string =
  'REQUEST_CREATE_JUDGEMENT_ON_MERITS';

export const REQUEST_GET_JUDGEMENT_ON_MERITS: string =
  'REQUEST_GET_JUDGEMENT_ON_MERITS';

export const REQUEST_GET_JUDGEMENT_ON_MERITS_MULTIPLE: string =
  'REQUEST_GET_JUDGEMENT_ON_MERITS_MULTIPLE';

export const REQUEST_GET_APPEAL_ON_MERITS_MULTIPLE: string =
  'REQUEST_GET_APPEAL_ON_MERITS_MULTIPLE';

export const REQUEST_GET_JUDGEMENT_ON_MERITS_APPEAL: string =
  'REQUEST_GET_JUDGEMENT_ON_MERITS_APPEAL';

export const REQUEST_CREATE_JUDGEMENT_ON_MERITS_CONTESTATION: string =
  'REQUEST_CREATE_JUDGEMENT_ON_MERITS_CONTESTATION';

export const REQUEST_UPDATE_CONTESTATION: string =
  'REQUEST_UPDATE_CONTESTATION';

export const REQUEST_UPLOAD_CONTESTATION_DOCUMENTS: string =
  'REQUEST_UPLOAD_CONTESTATION_DOCUMENTS';
export const REQUEST_CREATE_CIVIL_PROCEEDING =
  'REQUEST_CREATE_CIVIL_PROCEEDING';

export const SET_JUDGEMENT_ON_MERITS: string = 'SET_JUDGEMENT_ON_MERITS';
export const SET_JUDGEMENT_ON_MERITS_MULTIPLE: string =
  'SET_JUDGEMENT_ON_MERITS_MULTIPLE';

export const SET_APPEAL_ON_MERITS_MULTIPLE: string =
  'SET_APPEAL_ON_MERITS_MULTIPLE';
export const SET_JUDGEMENT_ON_MERITS_APPEAL: string =
  'SET_JUDGEMENT_ON_MERITS_APPEAL';
export const REQUEST_GET_JUDGEMENT_APPEAL: string =
  'REQUEST_GET_JUDGEMENT_APPEAL';
export const REQUEST_CREATE_JUDGEMENT_APPEAL: string =
  'REQUEST_CREATE_JUDGEMENT_APPEAL';
export const REQUEST_CREATE_MULTIPLE_JUDGEMENT_ADD: string =
  'REQUEST_CREATE_MULTIPLE_JUDGEMENT_ADD';

export const SET_JUDGEMENT_APPEAL: string = 'SET_JUDGEMENT_APPEAL';
export const RESET_LAWYER_LEGAL_PROCEEDING: string =
  'RESET_LAWYER_LEGAL_PROCEEDING';
export const REQUEST_ADD_DOCUMENT_CLAIM: string = 'REQUEST_ADD_DOCUMENT_CLAIM';

export const REQUEST_ADD_SUPPORT_DOCUMENT: string =
  'REQUEST_ADD_SUPPORT_DOCUMENT';

export const REQUEST_CIVIL_PARTY_SUPPORT_DOCUMENT: string =
  'REQUEST_CIVIL_PARTY_SUPPORT_DOCUMENT';

export const REQUEST_ADD_EXPERT_REPORT_SUPPORT_DOCUMENT: string =
  'REQUEST_ADD_EXPERT_REPORT_SUPPORT_DOCUMENT';

export const REQUEST_ADD_JUDGEMENT_ON_MERITS_SUPPORT_DOCUMENT: string =
  'REQUEST_ADD_JUDGEMENT_ON_MERITS_SUPPORT_DOCUMENT';

export const REQUEST_ADD_MULTIPLE_CIVIL_JUDGEMENT: string =
  'REQUEST_ADD_MULTIPLE_CIVIL_JUDGEMENT';

export const REQUEST_UPDATE_JUDGEMENT_ADD: string =
  'REQUEST_UPDATE_JUDGEMENT_ADD';

export const REQUEST_UPDATE_JUDGEMENT_ADD_DOCUMENT: string =
  'REQUEST_UPDATE_JUDGEMENT_ADD_DOCUMENT';

export const REQUEST_UPDATE_LAWYER_FIRM_REFERENCE: string =
  'REQUEST_UPDATE_LAWYER_FIRM_REFERENCE';
export const SET_LOCKED_CLAIM = 'SET_LOCKED_CLAIM';
export const LEGAL_PROCEEDINGS_STEPS = {
  EXPERT_REPORT: 'EXPERT_REPORT',
  JUDGEMENT_ON_MERITS: 'JUDGEMENT_ON_MERITS',
  APPEL: 'APPEL',
};

export const REQUEST_GET_DAHIR_AMOUNT: string = 'REQUEST_GET_DAHIR_AMOUNT';

export const SET_DAHIR_AMOUNT: string = 'SET_DAHIR_AMOUNT';

export const MODE = 'Bless%C3%A9'; // URL encodin 'Blessé'

export const PROCEDURE_TYPES = {
  FIRST_INSTANCE: 'FIRST_INSTANCE',
  APPEAL: 'APPEAL',
};

export const RESET_LAWYER_STEPS: string = 'RESET_LAWYER_STEPS';
export const PROCEDURE_STEPS_INDEX = featureService.hasFeature(
  FEATURES.PROVISION,
)
  ? {
      FIRST_INSTANCE: 0,
      APPEAL: 1,
      PROVISION: 2,
      CONTESTATION: 3,
    }
  : {
      FIRST_INSTANCE: 0,
      APPEAL: 1,
      CONTESTATION: 2,
    };

export const INSTANCE_LABELS_LAWYER = ['Premiére instance', 'Appel'];

export const INJURY_POST_KEY = {
  INJURED: '0',
  DECEASED: '2',
};
export const ListProceeding = [
  {
    id: 1,
    title: 'Procédure commerciale',
  },
  {
    id: 2,
    title: 'Procédure civile',
  },
  {
    id: 3,
    title: 'Procédure correctionelle',
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
];
export const TRANSACTION_STATE = {
  BLOCKED: 'BLOCKED',
  PENDING: 'PENDING',
  DONE: 'DONE',
};
